<template style="overflow-y:hidden">
  <div style="position: absolute; min-height:92%; min-width:100%; background-color: white;">
    <b-col class="col-lg-10" offset="1">
      <center>
        <b-container fluid>
          <div style=" position: relative; text-align: center; color: white;">
            <div class="homeDivStyle">
              <h3 style="text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;"><b>Welkom {{ $authService.username }} bij de Ideavelop Middleware Portal</b></h3>
            </div>
            <img src="..\assets\jean-fabric-background.png" style="border-radius: 5px; min-width: 100%; height: 500px" />
          </div>
          <b-row style="margin-top: 15px;" v-if="$authService.isAuthenticated">
            <b-col class="col-lg-4 homeColStyle">
              <div class="homeDivStyle">
                <a class="btn aStyle" href="#/articles"><b>Artikelen</b></a>
              </div>
              <img src="..\assets\artikelen.png" class="homeImgStyle" />
            </b-col>
            <b-col class="col-lg-4 homeColStyle">
              <div class="homeDivStyle">
                <a class="btn aStyle" href="#/logging" ><b>Logboeken</b></a>
              </div>
              <img src="..\assets\logboek.png" class="homeImgStyle" />
            </b-col>
            <b-col class="col-lg-4 homeColStyle">
              <div class="homeDivStyle">
                <a class="btn aStyle" href="#/downloadupload"><b>Import/Export</b></a>
              </div>
              <img src="..\assets\Download-Upload.png" class="homeImgStyle"  />
            </b-col>
            <!--<b-col class="col-lg-4" style=" position: relative; text-align: center; color: white; max-height:400px">
    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <a class="btn" href="#/jobs" style="line-height:350px; width: 500px; height: 350px; background-color: transparent; text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000; font-size: x-large; color: white"><b>Taken</b></a>
    </div>
    <img src="..\assets\Taken.png" style="border-radius: 30px; width: 500px; height: 350px; float: right" />
  </b-col>-->
          </b-row>
        </b-container>
      </center>
    </b-col>
    </div>
</template>

<script>  
  export default {
    name: 'Home',
    data() {
      return {       
      }
    }
  }
</script>

<style scoped>
  a.disabled {
    pointer-events: none;
  }
</style>
